__turbopack_context__.v({
  "activeTabBorder": "hfB-8a_activeTabBorder",
  "centeredTab": "hfB-8a_centeredTab",
  "tabHeader": "hfB-8a_tabHeader",
  "tabHeadlineButton": "hfB-8a_tabHeadlineButton",
  "tabHeadlineText": "hfB-8a_tabHeadlineText",
});
